export default __webpack_public_path__ + "static/media/PinkClockLight.777e2a7b.png";